import React from 'react'
import styles from './style.module.css'
import FooterBox from '../../components/FooterBox'
import { MdOutlinePhoneInTalk } from "react-icons/md";
import { MdOutlineMailOutline } from "react-icons/md";
import Button from '../../components/Button';
import { FaArrowRight } from "react-icons/fa6";
import FooterForm from '../../components/FooterForm/FooterForm';

const Product_4 = () => {
  return (
    <FooterBox background='white'>
        <FooterForm></FooterForm>
      </FooterBox>
  )
}

export default Product_4